import { render, staticRenderFns } from "./FormGeneralInfo.vue?vue&type=template&id=228c532a&scoped=true&"
import script from "./FormGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./FormGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./FormGeneralInfo.vue?vue&type=style&index=0&id=228c532a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228c532a",
  null
  
)

export default component.exports